import { render, staticRenderFns } from "./GladCourseForm.vue?vue&type=template&id=5daf7408&scoped=true"
import script from "./GladCourseForm.vue?vue&type=script&lang=js"
export * from "./GladCourseForm.vue?vue&type=script&lang=js"
import style0 from "./GladCourseForm.vue?vue&type=style&index=0&id=5daf7408&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daf7408",
  null
  
)

export default component.exports